<template>
	<div
		v-if="mountId"
		class="inter-article-container"
		:data-mount="mountId"
	>
		<a class="int-art-img" v-if="img" :href="clickUrl" v-metric="{module: 'int-art-img'}">
			<img alt="" :src="`${img}?resize=400px:*&output-quality=75`">
		</a>
	</div>
</template>

<script>
import ModuleLinks from 'webmd-dynamic-links/index.es6';

export default {
	data() {
		return {
			component: {},
			creativeId: '',
			variantId: '',
			mountId: false,
			img: false
		};
	},

	props: {
		moduleId: {
			type: Number,
		},
		articleNum: {
			type: Number,
			default: 1,
		},
	},

	mounted() {
		const self = this;
		const host = document.location.hostname;
		let module;
		let serverURL;

		self.mountId = new Date().getTime();

		if (host.includes('feature.webmd.com') || host.includes('devint.webmd.com') || host.includes('qa.webmd.com')) {
			if (!self.moduleId) {
				module = 4;
			} else {
				module = self.moduleId;
			}
		} else if (!self.moduleId) {
			module = 8;
		} else {
			module = self.moduleId;
		}

		if (host.includes('feature') || host.includes('devint')) {
			serverURL = 'https://img.devint.wbmdstatic.com';
		} else if (host.includes('qa')) {
			serverURL = 'https://img.qa.wbmdstatic.com';
		} else if (host.includes('preview')) {
			serverURL = 'https://img.lb.preview.wbmdstatic.com';
		} else if (host.includes('staging')) {
			serverURL = 'https://img.lb.staging.wbmdstatic.com';
		} else {
			serverURL = 'https://img.lb.wbmdstatic.com';
		}

		const dlOptions = {
			module,
			count: 1,
			params: {
				a: self.articleNum,
			},
		};

		ModuleLinks.fill(dlOptions).then((links) => {
			if (links && links[0] && links[0].component && links[0].component.loc) {
				self.component = links[0].component;
				self.creativeId = links[0].creativeId;
				self.variantId = links[0].variantId;
				self.clickUrl = links[0].url;

				window.webmd.iaMount = {
					id: self.mountId,
					config: JSON.parse(JSON.stringify(self.component.config)),
					clickUrl: self.clickUrl,
				};

				const script = document.createElement('script');
				script.src = self.component.loc.includes('http') ? self.component.loc : serverURL + self.component.loc;
				script.defer = true;

				document.head.appendChild(script);

			} else if (links && links[0] && links[0].img) {
				self.clickUrl = links[0].url;
				self.img = links[0].img;
			} else {
				self.mountId = false;
			}
		});
	},
};
</script>

<style lang="scss" scoped>
.int-art-img {
	display: block;
	margin: 1rem 0 2rem 0;
}
</style>